<template>
    <a-modal width="55%" title="编辑" :visible="visible" centered :destroy-on-close="true"
             :mask-closable="false"
             :confirm-loading="confirmLoading" @ok="onSubmit" @cancel="onClose">
        <div style="margin: 8px">
            <span style="color: red">请先下载《阳泉高新区数字化转型服务商申报书》模版，填写并盖章后上传扫描文件，再完善数字化转型服务商的其他信息进行保存；同步将纸质版（加盖公章、胶装成册）一式六份报送阳泉高新区科技创新中心。</span>
        </div>
        <a-form ref="ruleForm" layout="vertical" :model="form" :rules="rules" @submit="onSubmit">
            <a-row :gutter="24">
                <div class="hidden">
                    <a-form-item label="id" name="id">
                        <a-input v-model:value="form.id"/>
                    </a-form-item>
                </div>

                <a-col :span="24">
                    <a-form-item label="数字化转型服务商申报书(PDF)" name="applyFile">
                        <FilePartUpload v-model:value="form.applyFile" :is-pdf="true" :count="1" :size="1024"/>
<!--                        <FileUpload v-model:value="form.applyFile" :is-pdf="true" :count="1" :size="1024"/>-->
                        <div style="margin-top: 8px" v-if="!form.applyFile">
                            <a @click="downloadApplyFile" alt="阳泉高新区数字化转型服务商申报书">点击下载《阳泉高新区数字化转型服务商申报书》</a>
                            <span style="color: red">填写并盖章后上传扫描文件</span>
                        </div>
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="单位名称" name="unitName">
                        <a-input v-model:value="form.unitName" :disabled="true" placeholder="请输入单位名称"/>
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="单位性质" name="unitNatureCode">
                        <DictSelect v-model:value="form.unitNatureCode" :dict-name="'digital_unitNatureCode'"
                                    placeholder="请选择"/>
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="注册地" name="registerAddressCode">
                        <city-select :rootAreaId="0" v-model:areaIds="form.registerAddressCode"
                                     @change="onCitySelectChange"
                                     placeholder="请选择省/市/区"/>
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="成立时间" name="establishedTime">
                        <date-picker valueFormat="YYYY-MM-DD" v-model:value="form.establishedTime" style="width: 100%" placeholder="请选择注册时间"/>
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="申报服务商方向" name="serviceDirectionCode">
                        <DictSelect v-model:value="form.serviceDirectionCode" :dict-name="'digital_serviceDirectionCode'"
                                    placeholder="请选择"/>
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="服务行业" name="serviceTradeCode">
                        <DictSelect v-model:value="form.serviceTradeCode" :dict-name="'digital_serviceTradeCode'"
                                    placeholder="请选择"/>
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="办公地址" name="officeAddress">
<!--                        <a-input v-model:value="form.officeAddress" placeholder="请输入办公地址"/>-->
                        <a-input :readonly="true" v-model:value="form.officeAddress"
                                 placeholder="请选择地址"
                                 @click="showMap">
                            <template #addonAfter>
                                <p style="cursor: pointer;" @click="showMap">选择地址</p>
                            </template>
                        </a-input>
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="联系人" name="contactPeople">
                        <a-input v-model:value="form.contactPeople" placeholder="请输入联系人"/>
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="联系电话" name="contactWay">
                        <a-input v-model:value="form.contactWay" placeholder="请输入联系电话"/>
                    </a-form-item>
                </a-col>
            </a-row>
            <!--可编辑区域 end-->
        </a-form>
        <template #footer>
            <a-button key="back" @click="onClose">取消</a-button>
            <a-button key="submit" type="primary" @click="onSubmit">提交</a-button>
        </template>
    </a-modal>
    <BMapAddressSelect :defaultInfo="{ lng: addressInfo.longitude, lat: addressInfo.latitude }"
                       ref="bmapAddressSelect"
                       @confirmMapAddress="confirmMapAddress"></BMapAddressSelect>
</template>
<script>
import {formMixin} from "@/mixins";
import DictSelect from "@/components/other/DictSelect";
import { companyDigitalInfo } from "@/api/companyService";
// import FileUpload from "@/components/form/upload/FileUpload";
import dataCheck from "../../../../../utils/dataCheck";
import axios from "axios";
import {manageUseManualr} from "@/api/adminService";
import BMapAddressSelect from "@/components/BMapAddressSelect/oldIndex";
import FilePartUpload from "../../../../../components/form/upload/FilePartUpload";

export default {
    name: "SaveModal",
    components: {FilePartUpload, DictSelect,
        // FileUpload,
        BMapAddressSelect},
    mixins: [formMixin],
    data() {
        return {
            // 位置信息
            addressInfo: {},
            form: {
                id: null,
            },
            rules: {
                id:[],
                unitName:[],
                establishedTime:[dataCheck.required({msg:"请选择成立时间"})],
                registerAddress:[],
                registerAddressCode:[dataCheck.required({msg:"请选择注册地"})],
                officeAddress:[dataCheck.required({msg:"办公地址不能为空"})],
                unitNatureCode:[dataCheck.required({msg:"请选择单位性质"})],
                serviceDirectionCode:[dataCheck.required({msg:"请选择申报服务商方向"})],
                serviceTradeCode:[dataCheck.required({msg:"请选择服务行业"})],
                contactPeople:[dataCheck.required({msg:"联系人不能为空"})],
                contactWay:[dataCheck.required({msg:"联系电话不能为空"}), dataCheck.phone],
                applyFile:[dataCheck.required({msg:"请上传数字化转型服务商申报书(PDF)"})]
            },
            submitUrl: companyDigitalInfo.save
        }
    },
    methods:{
        /** 确认地图地址 */
        confirmMapAddress(addressInfo) {
            this.addressInfo = addressInfo;
            this.form.officeAddress = addressInfo.province + addressInfo.city + addressInfo.district + addressInfo.address
        },
        downloadApplyFile() {
            /*axios({
                methods: 'get',
                url: file_service.download + 'a1r1ueave9xsp5eyfhhv|阳泉高新区信息化项目评审专家库成员申请表.docx',
            }).then(() => {
                const link = document.createElement("a"); // 创建a标签
                link.href = file_service.download + "a1r1ueave9xsp5eyfhhv|阳泉高新区信息化项目评审专家库成员申请表.docx";
                link.target = '_blank';
                link.download = decodeURIComponent("阳泉高新区信息化项目评审专家库成员申请表.docx");// 文件重命名，若无需重命名，将该行删去
                link.click();
            })*/
            axios({
                methods: 'post',
                url: manageUseManualr.downloadFile,
                responseType: 'blob',
                headers: {
                    'content-type': 'application/x-www-form-urlencoded',
                    Authorization: 'Bearer' + this.$ls.get('token') || ''
                },
                params: {
                    type: 5
                }
            }).then(data => {

                this.spinShow = false
                const blob = new Blob([data.data], {type: "application/excel"});
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement("a"); // 创建a标签
                link.href = url;
                link.download = decodeURIComponent('阳泉高新区中小企业数字化转型服务商申报书.doc');
                link.click();
                URL.revokeObjectURL(url); // 释放内存
            })
        },
        onCitySelectChange(value, selectedOptions){
            this.form.registerAddressCode = value.join(',')
            this.form.registerAddress = selectedOptions.map(t=>t.title).join(" / ");

            console.log(value, selectedOptions)
        },
        showMap() {
            this.$refs.bmapAddressSelect.show();
        },
    }
}
</script>
<style scoped lang="less"></style>
